import {combineReducers} from 'redux'
import pathReducer from './FetchCall/fetchReducer'
import selectedReducer from './SelectedPath/selectedReducer'
import positionReducer from './Position/positionReducer'
import positionTicketReducer from './TicketZoom/ticketReducer'
import positionStartReducer from './PositionStart/positionStartReducer'
import positionEndReducer from './PositionEnd/positionEndReducer'
import tochceckBoxReducer from './TocCheckBox/tocCheckBoxReducer'
import dataListReducer from './DataTocList/dataListReducer'
import markerStartReducer from './MarkerStart/MarkerStartReducer'

import cercaFermataReducer from './CercaFermata/CercaFermataReducer'

import markerEndReducer from './MarkerEnd/MarkerEndReducer'
import markerStartReducer2 from './MarkerStart2/MarkerStartReducer2'
import markerEndReducer2 from './MarkerEnd2/MarkerEndReducer2'
import nomeFermataStartReducer from './NomeFermataStart/nomeFermataStartReducer'
import nomeFermataEndReducer from './NomeFermataEnd/nomeFermataEndReducer'
import regioneAereoPartenzaReducer from './RegioneAereoPartenza/regioneAereoPartenzaReducer'
import regioneAereoArrivoReducer from './RegioneAereoArrivo/regioneAereoArrivoReducer'
import PercorsoDrawerReducer from './PercorsoDrawer/PercorsoDrawerReducer'
import LayerDrawerReducer from './LayerDrawer/LayerDrawerReducer'
import LayerInformationReducer from './LayerInformation/LayerInformationReducer'
import LayerDivReducer from './LayerDiv/LayerDivReducer'
import ArrayLayerReducer from './ArrayLayer/ArrayLayerReducer'
import LatLongLayerReducer from './LatLongLayer/LatLongLayerReducer'
import layerFileReducer from './LayerFile/LayerFileReducer'
import layerUrlReducer from './LayerUrl/LayerUrlReducer'
import typeLayerReducer from './TypeLayer/TypeLayerReducer'
import tocSliderReducer from './TocSlider/TocSliderReducer'
import zoomToReducer from './ZoomTo/ZoomToReducer'
import tabellaAttributiReducer from './TabellaAttributi/TabellaAttributiReducer'
import queryReducer from './DataQuery/QueryReducer'
import openQueryReducer from './OpenQuery/OpenQueryReducer'
import configReducer from './Config/ConfigReducer'
import PercorsoTariffaReducer from './PercorsoTariffa/PercorsoTariffaReducer'
import PolyRealReducer from './PolyReal/PolyRealReducer'
import PositionTariffaStartReducer from './PositionTariffaStart/PositionTariffaStartReducer'
import PositionTariffaEndReducer from './PositionTariffaEnd/PositionTariffaEndReducer'
import BannerReducer from './Banner/BannerReducer'
import AziendaRealTimeReducer from './AziendaRealTime/AziendaRealTimeReducer'
import LineaRealTimeReducer from './LineaRealTime/LineaRealTimeReducer'
import MarkerErrorReducer from './MarkerError/MarkerErrorReducer'
import MappaReducer from './Mappa/MappaReducer'
const rootReducer = combineReducers({
    path: pathReducer,
    index: selectedReducer,
    position: positionReducer,
    positionTicket: positionTicketReducer,
    positionStart: positionStartReducer,
    positionEnd: positionEndReducer,
    tocCheckBox: tochceckBoxReducer,
    mappa: MappaReducer,
    dataList: dataListReducer,
    markerStart: markerStartReducer,
    markerEnd: markerEndReducer,
    markerStart2: markerStartReducer2,
    markerEnd2: markerEndReducer2,
    markerError : MarkerErrorReducer,
    cercaFermata: cercaFermataReducer,
    nomeFermataStart : nomeFermataStartReducer,
    nomeFermataEnd : nomeFermataEndReducer,
    regioneAereoPartenza : regioneAereoPartenzaReducer,
    regioneAereoArrivo : regioneAereoArrivoReducer,
    percorsoDrawer : PercorsoDrawerReducer,
    layerDrawer : LayerDrawerReducer,
    layerInformation : LayerInformationReducer,
    layerDiv : LayerDivReducer,
    latLongLayer : LatLongLayerReducer,
    arrayLayer : ArrayLayerReducer,
    percorsoTariffa : PercorsoTariffaReducer,
    lineaRealTime : LineaRealTimeReducer,
    aziendaRealTime : AziendaRealTimeReducer,
    banner : BannerReducer,
    polyReal : PolyRealReducer,
    positionTariffaStart : PositionTariffaStartReducer,
    positionTariffaEnd : PositionTariffaEndReducer,
    layerFile: layerFileReducer,
    layerUrl: layerUrlReducer,
    typeLayer: typeLayerReducer,
    tocSlider: tocSliderReducer,
    zoomTo: zoomToReducer,
    attributi: tabellaAttributiReducer,
    query:queryReducer,
    openQuery:openQueryReducer,
    config:configReducer
})

export default rootReducer;